import React from "react";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";
import { IMAGES } from "../config/siteConfig";

export default function ContactPage() {
  return (
    <>
      <PageHero
        label="Contact"
        title="Let's build"
        highlight="what's next."
        subtitle="Tell us about the roles you're hiring for or the workforce challenges you're solving. Our recruitment team will be in touch shortly."
        image={IMAGES.hero}
      />
      <Contact />
    </>
  );
}
